import { EmptySection } from '../components/Card.jsx';

export default function NotFound() {
  return (
    <EmptySection
      title="We couldn't find that page"
      body="The page may have moved, or it may not be part of your access level. Pick a section from the menu to carry on."
    />
  );
}
